import React, { memo, useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import {
  Text,
  IconPlus,
  Card,
  Space,
  Divider,
} from '@redlink/components/atoms';
import { createUseStyle } from '@redlink/assets/styles';
import { useLocale } from '@redlink/assets/locale';
import { getUserProfileQuery, useQuery } from '@redlink/services';
import { PurchasePagePage } from '../pages';
import { isMobile } from 'react-device-detect';

export const AddNewPageButton = memo(({ onPress, style }) => {
  const { styles, colors } = useStyle();
  const { dictionary } = useLocale();
  const [purchasePageIsVisible, setPurchasePageIsVisible] = useState(false);

  const {
    data: { UserProfile: { availablePageCount } = {} },
  } = useQuery(getUserProfileQuery);

  const isPageAvailable = availablePageCount > 0;

  return (
    <TouchableOpacity
      activeOpacity={0.7}
      onPress={() => {
        !isPageAvailable && setPurchasePageIsVisible(true);
        isPageAvailable && onPress();
      }}
    >
      <Card
        style={[
          styles.container,
          style,
          !isPageAvailable && styles.basicContainer,
        ]}
      >
        <View style={styles.iconContainer}>
          <IconPlus size={24} color={colors.blue12} />
        </View>
        <Space size={8} />
        <Text style={styles.placeholderText}>{dictionary.addNewPage}</Text>
        {isPageAvailable && (
          <>
            <Space size={8} />
            <Text
              style={styles.availableText}
            >{`${availablePageCount} ${dictionary.card}`}</Text>
          </>
        )}
        {!isPageAvailable && (
          <View>
            <Space size={4} />
            <Text style={styles.descriptionText}>
              {dictionary.addNewPageDescription}
            </Text>
            <Divider margin={8} color={colors.blue13} />
            <Text style={styles.actionText}>{dictionary.purchasePage}</Text>
          </View>
        )}
      </Card>
      <PurchasePagePage
        isVisible={purchasePageIsVisible}
        onDismiss={() => {
          setPurchasePageIsVisible(false);
        }}
      />
    </TouchableOpacity>
  );
});

const useStyle = createUseStyle(({ colors, size }) => ({
  container: {
    minWidth: 200,
    height: 230,
    backgroundColor: colors.blue1,
    alignItems: 'center',
    justifyContent: 'center',
    marginEnd: 16,
    marginBottom: 16,
  },
  basicContainer: {
    backgroundColor: colors.yellow3,
    ...(!isMobile && { maxWidth: 250 }),
  },
  placeholderText: {
    fontSize: 20,
    color: colors.blue12,
  },
  descriptionText: {
    fontSize: 14,
    color: colors.blue12,
  },
  actionText: {
    fontSize: 16,
    color: colors.blue12,
    alignSelf: 'center',
  },
  iconContainer: {
    backgroundColor: colors.blue13,
    borderRadius: 100,
    padding: 20,
  },
  availableText: {
    color: colors.white,
  },
}));
